export const fmtBRL = (v: number) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtBRL0 = (v: number) => `R$ ${Math.round(v).toLocaleString("pt-BR")}`;
export const fmtPct = (v: number, digits = 1) => `${v.toFixed(digits).replace(".", ",")}%`;
export const fmtNum = (v: number) => v.toLocaleString("pt-BR");
export const fmtDate = (iso: string) => new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

export const CHANNEL_LABEL: Record<string, string> = {
  meta: "Meta",
  google: "Google",
  tiktok: "TikTok",
};
export const CHANNEL_COLOR: Record<string, string> = {
  meta: "#1877F2",
  google: "#4285F4",
  tiktok: "#000000",
};

export const TIER_LABEL: Record<string, string> = {
  T1: "Baixo risco",
  T2: "Médio risco",
  T3: "Alto risco",
};

export const ACTION_LABEL: Record<string, string> = {
  increase_budget: "↑ Aumentar budget",
  decrease_budget: "↓ Reduzir budget",
  pause: "⏸ Pausar",
  resume: "▶️ Reativar",
  increase_bid: "↑ Aumentar lance",
  decrease_bid: "↓ Reduzir lance",
  duplicate: "📄 Duplicar",
  change_objective: "🎯 Mudar objetivo",
  add_negative_keyword: "➖ Negativar keyword",
  add_audience: "➕ Adicionar audiência",
  creative_refresh: "🎨 Refresh criativo",
  other: "⚙️ Outro",
};
